module.exports = __webpack_public_path__ + "static/whistle-top-rated-x2.c00a456d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whistle-top-rated-x2.png
// module id = 200
// module chunks = 43530729963404 263791100135453